import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_SERVICE,
});

instance.interceptors.response.use((res) => {
  if (res.data.success) {
    return Promise.resolve(res);
  }
  return Promise.reject(res);
});

const bffInstance = axios.create({
  baseURL: process.env.VUE_APP_UMS,
});
bffInstance.interceptors.response.use((res) => {
  if (res.data.success) {
    return Promise.resolve(res);
  }
  return Promise.reject(res);
});

export function getOrderProduct(params) {
  return instance.post("/api/v1/get/order/product/reviews", params);
}

export function getOrderSite(params) {
  return instance.post("/api/v1/get/order/site/reviews", params);
}

export function getOrderReviews(params) {
  return instance.post("/api/v1/get/order/product/reviews", params);
}

export function postSiteComment(params) {
  return instance.post("/api/v1/site/add", params);
}

export function postProductComment(params) {
  return instance.post("/api/v1/email/add", params);
}

export function queryDynamicQas(params) {
  return instance.post("/api/v1/get/review/qas", params);
}

export function quickRegister(params) {
  return bffInstance.post("/ums-service/userNewsLetter", params);
}

export function queryActivitySign(params) {
  return instance.get("/api/v1/queryActivitySign", { params });
}

export function queryUserId(params) {
  return instance.get("/api/v1/queryUserId", { params });
}
